import { Component, Input, Output, EventEmitter } from '@angular/core';

interface BaseButtonConfig {
  hidden?: boolean;
  disabled?: boolean;
  icon?: string;
  sizing?: 'expand' | 'compact';
}

interface TextButtonConfig extends BaseButtonConfig {
  text: string;
}

interface IconButtonConfig extends BaseButtonConfig {
  text?: undefined;
  icon: string;
}

export type ButtonConfig = TextButtonConfig | IconButtonConfig;

@Component({
  selector: 'app-footer-buttons',
  templateUrl: './footer-buttons.component.html',
  styleUrls: ['./footer-buttons.component.scss'],
})
export class FooterButtonsComponent {
  @Input() leftButton?: ButtonConfig;
  @Input() rightButton?: ButtonConfig;
  @Output() leftButtonClicked = new EventEmitter<Event>();
  @Output() rightButtonClicked = new EventEmitter<Event>();
  @Output() leftButtonDisabledClicked = new EventEmitter<Event>();
  @Output() rightButtonDisabledClicked = new EventEmitter<Event>();

  emitLeftButtonClicked(event: Event): void {
    if (this.leftButton?.disabled) {
      this.leftButtonDisabledClicked.emit(event);
    } else {
      this.leftButtonClicked.emit(event);
    }
  }

  emitRightButtonClicked(event: Event): void {
    if (this.rightButton?.disabled) {
      this.rightButtonDisabledClicked.emit(event);
    } else {
      this.rightButtonClicked.emit(event);
    }
  }
}
